<template>
  <div class="award-picture">
    <img :src="pic.picture" />
    <p>{{ pic.description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    pictures: {
      type: Object,
      default: () => ({
        description: '三橫一束王、大小的小、明天的明',
        picture: 'https://picsum.photos/600/400?random=11',
      }),
    },
  },
  data() {
    return {
      pic: this.pictures,
    };
  },
};
</script>

<style scoped lang="scss">
.award-picture {
  margin-bottom: 20px;
  img {
    box-shadow: 0 0 1px #000;
    width: 100%;
    vertical-align: middle;
  }
  p {
    margin: 5px;
    text-align: center;
  }
}
</style>
